import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as marketplaceReducer from "containers/Marketplace/reducer";

import MarketplaceSelect from "components/Marketplace/MarketplaceSelect";

class MarketplaceSelectContainer extends React.PureComponent {
  render() {
    return <MarketplaceSelect {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch) => ({
  selectMarketplace: (id) => dispatch(marketplaceReducer.selectMarketplace(id)),
  createInternalMarketplace: () => dispatch(marketplaceReducer.createInternalMarketplace())
});

const mapStateToProps = (state, ownProps) => {
  let marketplaces = marketplaceReducer.getMarketplaceArr(state);
  if (ownProps.hideGlobal) {
  }
  return {
    marketplaces: marketplaces,
    selectedMarketplace: marketplaceReducer.getSelectedMarketplace(state),
    isLoading: marketplaceReducer.getIsLoading(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MarketplaceSelectContainer);
